import { useState, type FormEvent } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { adminLogin } from '../lib/api';

export default function AdminLogin() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      await adminLogin(username.trim(), password);
      navigate('/admin/orders');
    } catch {
      setError('用户名或密码不正确');
    } finally {
      setBusy(false);
    }
  }

  return (
    <section className="stack">
      <div className="card">
        <h2>管理登录</h2>
        <p className="muted">确认闲鱼到账、重试生成任务、调整价格与链接。</p>
        <form className="stack" onSubmit={onSubmit} style={{ marginTop: '1rem' }}>
          <label className="field">
            用户名
            <input
              type="text"
              autoComplete="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </label>
          <label className="field">
            密码
            <input
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </label>
          {error ? <div className="error">{error}</div> : null}
          <div className="row">
            <button type="submit" className="btn" disabled={busy}>
              {busy ? '登录中…' : '登录'}
            </button>
            <Link className="btn btn-ghost" to="/">
              回首页
            </Link>
          </div>
        </form>
      </div>
    </section>
  );
}
